'use strict';

import dialog from '../../dialog';
import modalExport from '../../modal';
const modal = modalExport.global;
import util from '../../util';
import _ from 'lodash-es';
import video from "../../video";
import customVideoPlayer from './customVideoPlayer';

var videoplayer = null;
// guard to skip thumbnail sync when hovering
var skipThumbSync = false;

function getProductImageURL(viewType) {
    var pid = $("span[data-productid='productID']").data("pid");
    return util.appendParamsToUrl(Urls.getProductImages, { "pid": pid, "sz": viewType });
}

function lazyLoadThumbnails() {
    var viewType = util.isMobile() ? "large" : "icon";
    var thumbnailProductImageURL = getProductImageURL(viewType);
    //initMainImageCarousel();
    
    $.get(thumbnailProductImageURL).done(function (res) {
    	$("#thumbnails").html(res);
        initMainImageCarousel();
    });
}

function initMainImageCarousel() {
    const $thumbSlider = $('#thumbnails .product-images');
    const $mainSlider = $('.slider-main-image');

    // gallery thumnail carousel init and config
    $thumbSlider.slick({
        dots: false,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
		variableWidth: false,
        arrows: true,
        nextArrow: '<button class="slick-next slick-arrow"><i class="icon icon-cheveron-thin-left"></i></button>',
        prevArrow: '<button class="slick-prev slick-arrow"><i class="icon icon-chevron-thin-right"></i></button>',
        responsive: [			
			{
				breakpoint: 767,
				settings: {
					arrows: false,
                    vertical: false,
                    verticalSwiping: false,
                    variableWidth: true,
                    infinite: true,
                    centerMode: false
				}
			}
		]
    });

    //Initialize main image slider
    if (!$(".pdp-quickview").length) {
        $mainSlider.on('init', function () {
            $mainSlider.find('.slick-list').css({ height: '' });
            setTimeout(function () {
                $mainSlider.find('.slick-list').css({ height: '' });
            }, 300);
        }).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            arrows: true,
            dots: false,
            centerMode: true,
            fade: true,
            adaptiveHeight: true,
            focusOnSelect: false,
            responsive: [{
                breakpoint: 767,
                settings: {
                    arrows: false
                }
            }]
        });
    }

    //Guarded main → thumb sync
    $mainSlider
        .off('beforeChange.thumbSync')
        .on('beforeChange.thumbSync', function (e, slick, curr, next) {
            if (!skipThumbSync) {
                $thumbSlider.slick('slickGoTo', next);
                $thumbSlider.find('.slick-slide.slick-current').removeClass('slick-current');
                $thumbSlider.find('.slick-slide[data-slick-index="' + next + '"]').addClass('slick-current');
            }
            skipThumbSync = false;
        });

    //Thumbnail → main sync on drag/arrow
    $thumbSlider
        .off('beforeChange.thumbToMain')
        .on('beforeChange.thumbToMain', function (e, slick, curr, next) {
            $mainSlider.slick('slickGoTo', next);
        });

    //Thumbnail click handler
    $thumbSlider
        .off('click.thumbToMain')
        .on('click.thumbToMain', '.slick-slide:not(.slick-cloned)', function () {
            let idx = parseInt($(this).attr('data-slick-index'), 10);
            $mainSlider.slick('slickGoTo', idx);
            $thumbSlider.find('.slick-slide.slick-current').removeClass('slick-current');
            $(this).addClass('slick-current');
        });

    //Thumbnail hover: only change main image
    $thumbSlider.on('mouseenter.thumbHover', '.slick-slide:not(.slick-cloned)', function () {
        let idx = parseInt($(this).attr('data-slick-index'), 10);
        // prevent main→thumb sync this time
        skipThumbSync = true;
        $mainSlider.slick('slickGoTo', idx);
        $thumbSlider.find('.slick-slide.slick-current').removeClass('slick-current');
        $(this).addClass('slick-current');
    });

    //Secondary product-set slider (unchanged)
    $('#pdpMain .product-set-images .productthumbnail').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        arrows: true,
        dots: false,
        waitForAnimate: false,
        fade: true,
        adaptiveHeight: true,
        focusOnSelect: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                dots: true,
                arrows: false
            }
        }]
    });
    $thumbSlider.off('click.thumbToMain').on('click.thumbToMain', '.slick-slide:not(.slick-cloned)', function() {
        let idx = +$(this).attr('data-slick-index');
    
        // 1) Scroll the thumbnail strip to this slide
        $thumbSlider.slick('slickGoTo', idx);
    
        // 2) Show the matching main image
        $mainSlider.slick('slickGoTo', idx);
    
        // 3) Update the “selected” styling
        $thumbSlider
        .find('.slick-slide.slick-current').removeClass('slick-current');
        $(this).addClass('slick-current');
    });
}

function updatePinButton(imageUrl) {
    var pinButton = document.querySelector('.social-sharing a[data-share=pinterest]');

    if (!pinButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    
    // Use browser URL API instead of Node.js url module
    const urlObj = new URL(pinButton.href);
    urlObj.searchParams.set('media', new URL(newUrl, window.location.href).href);
    urlObj.searchParams.set('url', window.location.href);
    pinButton.href = urlObj.toString();
}

function updateFacebookButton(imageUrl) {
    var facebookButton = document.querySelector('.social-sharing a[data-share=facebook]');

    if (!facebookButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    
    // Use browser URL API instead of Node.js url module
    const urlObj = new URL(facebookButton.href);
    urlObj.searchParams.set('picture', new URL(newUrl, window.location.href).href);
    urlObj.searchParams.set('u', window.location.href);
    facebookButton.href = urlObj.toString();
}

function setVideoPlayer($slide) {
    var videoID = $('.product-video', $slide).attr("data-videoid");
    if(!videoID)    {return;}

    var $player = $("#videoplayer_pdp");
    if(!$player.length) {
        $slide.find(".product-video .video-wrapper").html('<div id="videoplayer_pdp"></div></div>');
        $slide.find(".product-video .video-wrapper").addClass('videoplayer-wrapper');
        $slide.find(".product-video").addClass('productplayer-video');
    } else {
        $slide.find(".product-video .video-wrapper").html("").append( $player.remove() );
    }
    videoplayer = video.playerThumbnail($("#videoplayer_pdp"), videoID);
}

function resetVideoPlayer() {
    if(videoplayer) {
        videoplayer.destroy();
        videoplayer = null;
    }
}

function getFullBleedOffset() {
    var viewport_width = $(window).width();
    if(viewport_width > 1024)       {return 90;}
    else if(viewport_width >= 768)   {return 50;}
    else                            {return 45;}
};


/**
 * @description returns the dom of the thumbnail image
 * @param {String} viewType
 * @param {String} pid
 * @param {object} targetContainer
 * @returns {String}
 */
function getTumbnailImgURL(viewType, pid, targetContainer, initCoroFlag) {
    let thumbnailProductImageURL = util.appendParamsToUrl(Urls.getProductImages, { "pid": pid, "sz": viewType });
    targetContainer = targetContainer ? targetContainer : "#thumbnails";
    return $.get(thumbnailProductImageURL).done(function (res) {
    	$(targetContainer).html(res);       
        
        if(initCoroFlag == true){
            initMainImageCarousel();
            this;
        }else{
            thumbnailSlickInit();
        }

    });
}

function thumbnailSlickInit() {
    $('#thumbnails .product-images').slick({
        dots: false,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        variableWidth: false,
        arrows: true,
        nextArrow: '<button class="slick-next slick-arrow"><i class="icon icon-cheveron-thin-left"></i></button>',
        prevArrow: '<button class="slick-prev slick-arrow"><i class="icon icon-chevron-thin-right"></i></button>',
        responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                vertical: false,
                verticalSwiping: false,
                variableWidth: true,
                infinite: true,
                centerMode: false
            }
        }]
    });
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
export default function () {
    if (dialog.isActive() || util.isMobile()) {
        $('#pdpMain .main-image').removeAttr('href');
    }
    updatePinButton();
    updateFacebookButton();
    lazyLoadThumbnails();
    resetVideoPlayer();
    // Custom Video Player
    customVideoPlayer();

    // bind zoom event handler
    $(document).on('click', '.pdp-main .product-primary-image .product-image', function (evt) {
        evt.preventDefault();
        var viewType = "zoom";
        // var thumbnailProductImageURL = getSingleProductImageURL(viewType);
        // modal.renderByUrl(thumbnailProductImageURL);

        var zoomImageUrl = null;
        if($('.productthumbnail').length > 1) {
        	zoomImageUrl = $('.productthumbnail.slick-current').data('zoomimg');
        } else {
        	// for only one thumbnail, select that one image
        	zoomImageUrl = $($('.productthumbnail')[0]).data('zoomimg');
        }

        !$(this).hasClass('video-thumbnail') && modal.renderContent('<img src="' + zoomImageUrl + '">');

        modal.addCustomClass('productImageZoom'); // Added condition so when custom video avialble on product thumbnail then modal should be open

    });

    // handle product thumbnail mouseenter event
    $('#thumbnails .product-images').on('click', '.slick-slide', function() {
        $('.slider-main-image').slick('slickGoTo', $(this).data('slickIndex'));
        $('#thumbnails .product-images .slick-slide')
            .removeClass('slick-current')
            .filter('[data-slick-index="' + $(this).data('slickIndex') + '"]')
            .addClass('slick-current');
    });    

    // On before slide change
	$(document).on('beforeChange', '.slick-slider.slider-main-image', function(event, slick, currentSlide, nextSlide) {
		var $this = $(this).find(".slide").eq(nextSlide);
        var colorway = $this.find("[data-colorway]").attr('data-colorway');
		if(colorway) {
			$('body').removeClass("colorway-solid-white colorway-solid-black colorway-transparent-white colorway-transparent-black").addClass(colorway);  
		}
	});

    video.init(function () {
        $(document).on('afterChange', '.slick-slider.slider-main-image', function(event, slick, currentSlide) {
            resetVideoPlayer();
            setVideoPlayer($(this).find(".slide").eq(currentSlide));
        });
    });
};

export { lazyLoadThumbnails, resetVideoPlayer, setVideoPlayer, getTumbnailImgURL };